import React from 'react';
import ChiffrageContainer from './components/ChiffrageContainer';

const Chiffrage: React.FC = () => {
  return (
    <div className="chiffrage-app">
      <ChiffrageContainer />
    </div>
  );
};

export default Chiffrage;
